import { defaults, allowed } from '../../../../lib/genericReducer';

export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    responseMessage: null,
    purchases: {},
    sales: {},
    adjustments: {},
    breedings: {},
    transfers: {},
    summaries: {},
    stockflows: [],
    agistments: [],
    livestock_incomes: [],
    activeCattleTab: '1',
    activeSheepTab: '1',
    activeLiveStockTab: '1',
    activeAgistmentTab: '10',
    isLivestockAssumptionsToggled: false,
  },
  action,
) {
  // Set expected reducer types
  const types = ['LIVESTOCK'];
  if (!allowed(types, action)) return state;

  const updatedState = {
    ...state,
    ...defaults(action),
  };

  switch (action.type) {
    case 'SET_LIVESTOCK_ASSUMPTION_TOGGLE': {
      return {
        ...updatedState,
        isLivestockAssumptionsToggled: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_PURCHASES_FULFILLED': {
      return {
        ...updatedState,
        purchases: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_SALES_FULFILLED': {
      return {
        ...updatedState,
        sales: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_ADJUSTMENTS_FULFILLED': {
      return {
        ...updatedState,
        adjustments: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_BREEDINGS_FULFILLED': {
      return {
        ...updatedState,
        breedings: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_TRANSFERS_FULFILLED': {
      return {
        ...updatedState,
        transfers: action.payload,
      };
    }

    case 'FETCH_LIVESTOCK_AGISTMENTS_FULFILLED': {
      return {
        ...updatedState,
        agistments: action.payload,
      };
    }

    case 'FETCH_LIVESTOCK_SUMMARIES_FULFILLED': {
      return {
        ...updatedState,
        summaries: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_STOCKFLOWS_FULFILLED': {
      return {
        ...updatedState,
        stockflows: action.payload,
      };
    }
    case 'FETCH_LIVESTOCK_INCOMES_FULFILLED': {
      return {
        ...updatedState,
        livestock_incomes: action.payload,
      };
    }
    case 'SET_LIVESTOCK_CATTLE_ACTIVE_TAB': {
      return {
        ...updatedState,
        activeCattleTab: action.payload,
      };
    }
    case 'SET_LIVESTOCK_SHEEP_ACTIVE_TAB': {
      return {
        ...updatedState,
        activeSheepTab: action.payload,
      };
    }
    case 'SET_LIVESTOCK_OTHER_LIVESTOCK_ACTIVE_TAB': {
      return {
        ...updatedState,
        activeLiveStockTab: action.payload,
      };
    }
    case 'SET_LIVESTOCK_AGISTMENT_ACTIVE_TAB': {
      return {
        ...updatedState,
        activeAgistmentTab: action.payload,
      };
    }
    default:
      break;
  }

  return updatedState;
}
